var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.504,
    height: 39.501,
    viewBox: "0 0 31.504 39.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.828)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.828)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.72,24.679a.611.611,0,0,0,.611-.611V22.109a3.367,3.367,0,0,0-1.8-2.977V2.641a.611.611,0,0,0-.611-.611H79.386V.611A.611.611,0,0,0,78.775,0H59.193a.611.611,0,1,0,0,1.223H78.164V18.746H67.715a2.129,2.129,0,0,1-1.993-1.358l-.542-1.381a3.345,3.345,0,0,0-3.131-2.134H55.528V1.223h1.627a.611.611,0,1,0,0-1.223H54.917a.611.611,0,0,0-.611.611V13.992a3.369,3.369,0,0,0-2.478,3.244V36.393A3.112,3.112,0,0,0,54.936,39.5H80.224a3.112,3.112,0,0,0,3.108-3.108V26.106a.611.611,0,0,0-1.223,0V36.393a1.888,1.888,0,0,1-1.886,1.886H54.936a1.888,1.888,0,0,1-1.886-1.886V17.237A2.144,2.144,0,0,1,55.192,15.1h6.857a2.129,2.129,0,0,1,1.993,1.358l.542,1.381a3.345,3.345,0,0,0,3.131,2.134H79.968a2.144,2.144,0,0,1,2.141,2.141v1.959A.611.611,0,0,0,82.72,24.679Zm-2.412-5.916a3.385,3.385,0,0,0-.341-.017h-.581V3.252h.922Z",
    transform: "translate(-51.828)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.724 3.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.41,49.288a3.263,3.263,0,1,0-3.8,0,3.26,3.26,0,0,0-1.365,2.652.611.611,0,1,0,1.223,0,2.04,2.04,0,0,1,4.081,0,.611.611,0,1,0,1.223,0A3.26,3.26,0,0,0,133.41,49.288Zm-1.9-.611a2.04,2.04,0,1,1,2.04-2.04A2.043,2.043,0,0,1,131.512,48.676Z",
    transform: "translate(-128.249 -43.373)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.7 4.104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.236,53.194h-1.3a.611.611,0,1,0,0,1.223h1.3a.611.611,0,0,0,0-1.223Z",
    transform: "translate(-335.327 -53.194)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.512 4.104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.925,53.194h-5.15a.611.611,0,0,0,0,1.223h5.15a.611.611,0,0,0,0-1.223Z",
    transform: "translate(-242.164 -53.194)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.512 16.074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.261,208.351h-8.485a.611.611,0,0,0,0,1.223h8.485a.611.611,0,1,0,0-1.223Z",
    transform: "translate(-242.164 -208.351)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.644 13.082)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.678,169.562h-4.354a.611.611,0,1,0,0,1.223h4.354a.611.611,0,1,0,0-1.223Z",
    transform: "translate(-295.713 -169.562)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.512 13.082)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.869,169.562h-2.094a.611.611,0,0,0,0,1.223h2.094a.611.611,0,0,0,0-1.223Z",
    transform: "translate(-242.164 -169.562)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.512 7.096)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.261,91.982h-8.485a.611.611,0,0,0,0,1.223h8.485a.611.611,0,1,0,0-1.223Z",
    transform: "translate(-242.164 -91.982)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.512 10.089)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.261,130.773h-8.485a.611.611,0,0,0,0,1.223h8.485a.611.611,0,1,0,0-1.223Z",
    transform: "translate(-242.164 -130.773)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocs);
export default __webpack_public_path__ + "static/media/icon-docs.4084ad45fc54dcf8626755f421cbc34f.svg";
export { ForwardRef as ReactComponent };